<template>
  <section>
    <div class="collect">
      <p class="title">收藏商品</p>
      <div class="collectGoods_list flex">
        <div class="collectGoods_item" v-for="(item,index) in shoucanglist.data" :key="index">
          <a :href="'#/goodsdetail?id='+item.tid" target="_blank" rel="noopener noreferrer">
            <div class="goodsimg">
            <img :src="item.indexpic" alt srcset />
          </div>
          <div class="price flex ju-be">
              <span class="price_num">￥{{item.param1}}</span>
              <!-- <span class="sale">售出{{item.price}}件</span> -->
          </div>
          <div class="goodsname ellipsis-2">  {{item.title}} </div>
          </a>
          <!-- <span class="shopname">自营</span> -->
         
        </div>
      </div>
    </div>
    <el-pagination
      class="fenye"
      background
      layout="prev, pager, next"
      :page-size="shoucanglist.per_page"
      @current-change="currentPage"
      :total="shoucanglist.total"
    ></el-pagination>
  </section>
</template>

<script>
export default {
  name: "Coupons",
  data() {
    return {
      page: 1,
      shoucanglist:{},
    };
  },
  props: {},
  methods: {
    // 改变当前页
    currentPage(e) {
      this.page = e;
      this.getbalance();
    },
    // 收藏商品
    async getshoucanglist(){
      // console.log("this.productdetail.isfav",this.productdetail.isfav)
      let res = await this.$fetch("member/favlist", {
        body: {
          act:'list',
          type: 1,page:this.page,
        }
      });
      console.log("res",res)
      this.shoucanglist=res;
    },
  },
  mounted() {
    this.getshoucanglist()
  }
};
</script>
<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/components/collectGoods.vue